import { dateFormat } from "../../const/date";
import sanitizeHtml from "sanitize-html";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });

  const getTranslated = (key: string) => {
    const text = key || ""; //data json에서 호출
    const sanitizedText = sanitizeHtml(text, {
      allowedTags: ["br", "em", "span"], //허용할 태그 지정
    });
    return { __html: sanitizedText };
  };

  return (
    <div
      id="blog"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 bg-[radial-gradient(ellipse_80%_75%_at_65%_55%,#d8edff_0%,#eaf5ff_40%,#f6fbff_75%,#ffffff_100%)]"
    >
      <div className="max-w-[1200px] mx-auto">
        {/* Heading */}
        <div className="text-center">
          <p className="font-medium text-base lg:text-xl">
            실제 작업현장이 궁금하신 고객님들을 위해
          </p>
          <h2 className="font-medium inline-block bg-gradient-to-r from-[#007bff] to-[#ff0000] bg-clip-text text-transparent">
            원킬케어 BLOG 작업사례
          </h2>
        </div>

        <div className="relative w-full h-fit max-w-[1400px] min-h-36 mx-auto grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-5 text-black mt-8">
          {blog.map((v, i) => (
            <div
              data-aos="fade-up"
              key={i}
              onClick={() => window.open(v.link[0])}
              className={
                i > 7
                  ? "hidden lg:block relative w-full h-full"
                  : "relative w-full h-full"
              }
            >
              <div className="relative w-full h-full rounded-xl grid bg-white p-2 md:p-3 text-left border cursor-pointer transition-all duration-300 overflow-hidden">
                <p
                  className={`relative w-full text-primary whitespace-nowrap overflow-hidden overflow-ellipsis lg:text-lg h-fit mb-1.5 lg:mb-3`}
                >
                  {v.title[0]}
                </p>
                <small
                  className={`relative w-full whitespace-nowrap md:whitespace-normal overflow-hidden overflow-ellipsis h-fit md:h-9 my-2 lg:my-0 break-words md:line-clamp-2 text-sm opacity-60`}
                  dangerouslySetInnerHTML={getTranslated(v.description[0])}
                  // dangerouslySetInnerHTML={{ __html: v.description[0] }}
                ></small>
                <div className="md:pt-2 lg:mt-3 3xl:mt-4 lg:flex justify-between items-end">
                  <small className="hidden xl:block opacity-40 lg:text-sm">
                    {dateFormat(v.pubDate[0])}
                  </small>
                  <small className="text-main lg:text-sm">
                    {v.category[0]}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  parseString(data, (err: any, result: any) => {
    if (err) {
      console.error("XML 파싱 에러:", err);
      return;
    }

    const items = result?.rss?.channel?.[0]?.item;
    if (Array.isArray(items)) {
      items.slice(0, 9).forEach((v: any) => {
        dataArr.push({
          title: v.title,
          link: v.link,
          description: v.description,
          pubDate: v.pubDate,
          category: v.category,
        });
      });
    } else {
      console.warn("item 배열이 없습니다.");
    }
  });

  return dataArr;
};
